import { ReactNode } from 'react';
import classes from './WizardField.module.css';

export type WizardFieldControlProps = {
  id: string;
  'aria-invalid': true | undefined;
  'aria-describedby': string | undefined;
};

type WizardFieldProps = {
  id: string;
  label: string;
  description?: string;
  error?: string;
  size?: 'sm' | 'md';
  children: (controlProps: WizardFieldControlProps) => ReactNode;
};

/** Label, description, control and validation message laid out as a Designsystemet field. */
export const WizardField = ({
  id,
  label,
  description,
  error,
  size,
  children,
}: WizardFieldProps) => {
  const descriptionId = description ? `${id}-description` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [descriptionId, errorId].filter(Boolean).join(' ');

  return (
    <div className="ds-field" data-size={size}>
      <label className="ds-label" data-size={size} htmlFor={id}>
        {label}
      </label>
      {description && (
        <p
          className={`ds-paragraph ${classes.description}`}
          data-size="sm"
          id={descriptionId}
        >
          {description}
        </p>
      )}
      {children({
        id,
        'aria-invalid': error ? true : undefined,
        'aria-describedby': describedBy || undefined,
      })}
      {error && (
        <p className="ds-validation-message" data-color="danger" id={errorId}>
          {error}
        </p>
      )}
    </div>
  );
};
